import { combineReducers } from 'redux';

import {
    CAMPAIGNS_LOADED,
    CAMPAIGNS_LOADING,
    CAMPAIGN_CREATED,
    CAMPAIGN_UPDATED,
} from 'modules/campaign/actions/campaign.action';
import { AUTH_LOGOUT } from 'modules/auth/actions/authentication.action';

export const loadingCampaigns = (state = false, action) => {
    switch (action.type) {
        case CAMPAIGNS_LOADING:
            return action.payload;
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

export const campaigns = (state = null, action) => {
    switch (action.type) {
        case CAMPAIGNS_LOADED:
            return action.payload.map(({ campaignRange, ...el }) => ({
                ...el,
                campaign_ranges: campaignRange,
            }));
        case CAMPAIGN_CREATED:
            if (Array.isArray(state)) {
                return [
                    ...state,
                    {
                        ...action.payload,
                        campaign_ranges: action.payload.campaignRange,
                    },
                ];
            }
            return [
                action.payload,
            ];
        case CAMPAIGN_UPDATED:
            return [
                ...state.filter(el => el.pk_campaign === action.payload.pk_campaign),
                action.payload,
            ];
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};

export default combineReducers({
    loadingCampaigns,
    campaigns,
});
